import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocalStorage } from 'src/app/appCommon/Enums/enum';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ObservableService } from 'src/app/appServices/ObservableService/observable.service';
import { environment } from 'src/environments/environment';
const AUTH_API = environment.teleUrl;

@Component({
  selector: 'app-tpa-case-analysis',
  templateUrl: './tpa-case-analysis.component.html',
  styleUrls: ['./tpa-case-analysis.component.scss'],
})
export class TpaCaseAnalysisComponent implements OnInit {

  accessCase: string=`${AUTH_API}Case/Edit/?id=`;
  tPACaseAnalysisList: any = [];
  totalRecords = 0;
  pageNumber = 1;
  rows = 50;
  sortOrder = 'Asc';
  sortCol = '';
  filterVal = '';
  cols: any;
  loader: any;
  excel_chartDisabe: any;
  showProgressSpinner:boolean = false;
  UId: any;
  RoleName: any;
  lazyLoadSearchBool: boolean = false;
  private subscription: Subscription[] = [];
  roleForFacility: boolean = false;

  constructor(public analyzeService: AnalyzeService,private helperService: HelperService,
    private Observable:ObservableService,private authService: AuthService) { }
  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.analyzeService._facilityPiComponent.TpaCaseAnalysisComponent = this;
    this.roleForFacility = this.authService.roleForFacility();
    if ((this.analyzeService._facilityPiRecord.TpaCaseAnalysisRecord != null) && (this.analyzeService._facilityPiRecord.TpaCaseAnalysisRecord != undefined)) {
      this.tPACaseAnalysisList = this.analyzeService._facilityPiRecord.TpaCaseAnalysisRecord;
    }
    if(this.analyzeService._facilityPiRecord.TpaCaseAnalysisRecord == undefined){
      if(this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj != undefined){
      this.analyzeService._facilityPiComponent.FacilityPIComponent.getFacilityDashboardValues();
      this.lazyLoadSearchBool = true;
      }
    }else{
      this.lazyLoadSearchBool = false;
    }
  }
  ngAfterContentInit(): void {
    if(this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj != undefined){
        this.Observable.value$.subscribe((val) => {
          // this.showProgressSpinner = val;
        });
  }
  }

  getTPACaseAnalysisValues(excel_chartDisabe: any,loader: any) {
    this.showProgressSpinner = true;
    this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.Sort.FieldName = this.sortCol;
    this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.Sort.Order = this.sortOrder;
    this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.Take = this.rows;
    this.subscription.push(
    this.analyzeService.getTPAAnalysisValues(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj).subscribe({
      next: (res: any) => {
        if (res) { 
          this.showProgressSpinner = false;
          this.tPACaseAnalysisList = res.data;
          this.totalRecords = res.Total;
          this.analyzeService._facilityPiRecord.TpaCaseAnalysisRecord = this.tPACaseAnalysisList;
          this.analyzeService.currentDateTime();
          loader.value = false;
          excel_chartDisabe.value = false;
        }
      },
      error: (err: any) => { },
    })
    );
  }
  lazyLoadSchedules(event: any) {
    if (event != undefined) {
      this.rows = event.rows;
      this.pageNumber = event.first / this.rows + 1;
      this.sortOrder =
        event.multiSortMeta == undefined || event.multiSortMeta[0].order == -1
          ? 'DESC'
          : 'ASC';
      this.sortCol =
        event.multiSortMeta == undefined
          ? 'FacilityName'
          : event.multiSortMeta[0].field;
      this.filterVal =
        event.filters.global == undefined ? '' : event.filters.global.value;
        if(this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj != undefined){
                  this.loader = { 'value': true };
                  this.excel_chartDisabe = { 'value': true,'excel_show':true, 'facility_charts_Show': false,'pi_chart_show':false };
                  this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj.PageNumber = this.pageNumber;
                  this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj.Take = this.rows;
                  this.analyzeService._facilityPiFilterObj.TpaCaseAnalysisDataObj.Skip = this.rows * this.pageNumber - this.rows;
                  if(this.rows != 50 || this.pageNumber != 1 || event.multiSortMeta != undefined){
                    this.lazyLoadSearchBool = false;
                  }
                  if(this.lazyLoadSearchBool == false){
                    this.getTPACaseAnalysisValues(this.excel_chartDisabe,this.loader);
                  }

                }
    }
  }
  ngOnDestroy() {
    if(this.subscription.length != 0){
      this.subscription.forEach((i:any)=>{
        i.unsubscribe();
      })
    }
     Object.getOwnPropertyNames(this)
      .filter(propName => Array.isArray((<any>this)[propName]))
      .forEach(propName => (<any>this)[propName] = []);
     
     }
}
